export const SUPPORTED_LANGUAGES = [
    "arabic",
    "armenian",
    "bulgarian",
    "danish",
    "dutch",
    "english",
    "finnish",
    "french",
    "german",
    "greek",
    "hungarian",
    "indian",
    "indonesian",
    "irish",
    "italian",
    "lithuanian",
    "nepali",
    "norwegian",
    "portuguese",
    "romanian",
    "russian",
    "serbian",
    "slovenian",
    "spanish",
    "swedish",
    "turkish",
    "ukrainian"
];

//# sourceMappingURL=languages.js.map